import React from 'react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/qiTyC42EW3ToLrcjC3DG7p/WhatsApp_Image_2026-05-22_at_09.04.36-removebg-preview_(1).png';
interface AppIconProps {
  size?: number;
  className?: string;
}
export function AppIcon({
  size = 40,
  className = ''
}: AppIconProps) {
  return <img src={LOGO_URL} alt="Aurora Care" width={size} height={size} className={`object-contain ${className}`} style={{
    width: size,
    height: size
  }} data-id="element-136" data-mp="233p1g4xvbjmj" />;
}
// URL string for use in manifest/meta tags
export const appIconUrl = LOGO_URL;